import { AlgoliaHitTransformer } from '../transformers/AlgoliaHitTransformer';
import type { AlgoliaProductHit } from '@jbhi-fi/apis/src/algolia/types/AlgoliaProductHit';

export const getMarketplaceTrackingValuesFromHit = (hit: AlgoliaProductHit) => {
  const marketplaceSeller = AlgoliaHitTransformer.toMarketplaceSeller(hit);
  const isMarketplaceProduct = marketplaceSeller?.id;
  return {
    marketplace_product: isMarketplaceProduct ? 'Y' : 'N',
    marketplace_seller_type: isMarketplaceProduct ? '3P' : 'N/A',
    marketplace_seller_name: isMarketplaceProduct ? marketplaceSeller?.name ?? 'N/A' : 'N/A',
  };
};
